// extracted by mini-css-extract-plugin
module.exports = {"icon-arrow":"Arrow_icon-arrow__nZGbn"};